/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportCampaignsV2MutationRequest,
  ExportCampaignsV2MutationResponse,
  ExportCampaignsV2400,
  ExportCampaignsV2500,
} from '../types/ExportCampaignsV2'

function getExportCampaignsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/contacts/campaigns/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async campaigns export.
 * Request body:
 * {
 * "selected_columns": ["name", "description", "company_type"],
 * "export_type": "csv",
 * "filter_params": { ... },
 * "sort": "-created"
 * }
 * Returns 202:
 * {
 * "request_id": 123,
 * "status": "pending",
 * "progress_percentage": 0,
 * "item_count": 0
 * }
 * @summary Start an async campaigns export
 * {@link /api/v1/contacts/campaigns/export/v2/}
 */
export async function exportCampaignsV2(
  data: ExportCampaignsV2MutationRequest,
  config: Partial<RequestConfig<ExportCampaignsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportCampaignsV2MutationResponse,
    ResponseErrorConfig<ExportCampaignsV2400 | ExportCampaignsV2500>,
    ExportCampaignsV2MutationRequest
  >({
    method: 'POST',
    url: getExportCampaignsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
